<template>
  <el-dialog
    :visible.sync="hotAirDialogVisible"
    width="500px"
    top="6vh"
    :before-close="closeDialog"
  >
    <template slot="title"> <title-icon />热风幕 </template>
    
    <div class="content">
      <div class="img">
        <img width="100%" :src="monitorType11025 == 'true' ? img_on : img_off" />
      </div>
      <div>
        <p>
          <span style="margin-left: 20px; margin-right: 10px">运行状态:</span>
          <template v-if="monitorType11025 == 'true'">
            <span class="statusClass autoHand"> 运行 </span>
          </template>
          <template v-else>
            <span class="statusClass stop"> 停止 </span>
          </template>
        </p>
        <p>
          <span style="margin-left: 20px; margin-right: 10px">风机控制:</span>
          <template v-if="monitorType11029 == 'true'">
            <span class="statusBorder autoHand" @click="showInner('11029', false)"> 停止 </span>
          </template>
          <template v-else>
            <span class="statusBorder stop" @click="showInner('11029', true)"> 启动 </span>
          </template>
        </p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  setPoint
} from '@/api/business/base/tenant/map'
export default {
  props: {
    hotAirDialogVisible: {
      type: Boolean
    },
    // 报警信息
    deviceInfo: {
      type: Object,
    },
    // 设备类型编码
    deviceType: {
      type: String,
    },
  },
  computed: {
    telecommandMessage() {
      return this.$store.getters.telecommandMessage;
    },
    telemeteringMessage() {
      return this.$store.getters.telemeteringMessage;
    },
    getDeviceType() {
      return this.deviceType;
    }
  },
  watch: {
    //侦听遥信数据
    telecommandMessage(message) {
      this.telecommandMessageInfo(message);
    },
    //侦听遥测数据
    telemeteringMessage(message) {
      this.telemeteringMessageInfo(message);
    },
    getDeviceType: function () {
      this.deviceTypeChange();
    }
  },
  data() {
    return {
      innerVisible: false,
      currentDeviceType: '11106',
      img_on: require('@/assets/beijing_img/hotAir_on.png'),
      img_off: require('@/assets/beijing_img/hotAir_off.png'),
      monitorType11029: null,
      monitorType11025: null
    }
  },
  methods: {
    isShowDialog() {
      if (this.hotAirDialogVisible) {
        this.initMonitorRedisData();
      }
    },
    initMonitorRedisData() {
      this.historyTable = []
      this.deviceInfo.monitorList.map(v => {
        this.findMonitorTypeValue(v.monitorType);
      })
    },
    findMonitorTypeValue(monitorType) {
      let monitorObj = this.deviceInfo.monitorList.find((item) => {
        return item.monitorType == monitorType;
      })
      this["monitorType" + monitorType] = monitorObj.value;
    
    },
    findSourceCodeValue(message) {
      if (this.deviceInfo != null) {
        let monitorObj = this.deviceInfo.monitorList.find((item) => {
          return item.historyTable == message.sourceCode;
        })
        if (monitorObj != undefined) {
          this["monitorType" + monitorObj.monitorType] = message.value;
          
        }
      }
    },
    closeDialog() {
      this.$emit('update:hotAirDialogVisible', false)
    },
    //遥信
    telecommandMessageInfo(message) {
      this.findSourceCodeValue(message);
    },
    //遥测
    telemeteringMessageInfo(message) {
      this.findSourceCodeValue(message);
    },
    controlPoint(monitorType, value) {
      //  this.$emit('change', true)
      if (this.deviceInfo != null) {
        let monitorObj = this.deviceInfo.monitorList.find((item) => {
          return item.monitorType == monitorType;
        })
        setPoint({ "sourceCode": monitorObj.historyTable, "value": value })
      }
    },
    showInner(monitorType, value) {
      this.$confirm('确认是否状态切换?', '设备状态切换', {
          confirmButtonText: '确认',
          cancelButtonText: '关闭',
          type: 'warning',
          center: true
        }).then(() => {
          this.controlPoint(monitorType, value)
        }).catch(() => {
                 
        });
    }
  }

}
</script>

<style lang="scss" scoped>
.content {
  display: grid;
  grid-template-columns: 54% 40%;
  padding: 20px 0;
}
.statusClass {
  display: inline-block;
  width: 75px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  color: #fff;
  background-color: #2f5597;
  margin-right: 10px;
  border-radius: 4px;
}
.statusClass.stop {
  background-color: #a6a6a6;
}

.statusClass {
  display: inline-block;
  width: 75px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  background-color: #20ebb6;
  margin-right: 10px;
}
.statusBorder {
  cursor: pointer;
  display: inline-block;
  width: 75px;
  height: 26px;
  text-align: center;
  line-height: 22px;
  border: 2px solid #00b050;
  margin-right: 10px;
}
</style>